<template>
  <b-modal hide-footer id="modalCaderno" body-class="modal-conteudo" header-class="">
    <template slot="modal-header">
      <div class="row w-100" v-if="licao">
        <div class="col-12 col-md-4 mb-3 mb-md-0">
          <p>Lição</p>
          <p>{{ licao.nome }}</p>
        </div>
        <div class="col-12 col-md-4">
          <p>Curso</p>
          <p>{{ nomeCurso }}</p>
        </div>
        <div class="col-12 col-md-4 mb-3 mb-md-0">
          <p>Categoria</p>
          <p>{{ nomeCategoria }}</p>
        </div>
        <button type="button" class="close" aria-label="Close" @click="$bvModal.hide('modalCaderno')">
          <i class="far fa-times-circle"></i>
        </button>
      </div>
    </template>

    <div class="caderno">
      <div class="conteudo-caderno" v-if="licao && licao.topicos && licao.topicos.length">
        <template v-for="topico in licao.topicos">
          <h3>{{ topico.nome }}</h3>
          <p v-for="anotacao in topico.anotacoes" v-html="anotacao.nome" style="white-space: pre-line;"></p>
        </template>
      </div>
      <div class="conteudo-caderno" v-else>
        <p>Nenhuma anotação preenchida.</p>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'ModalCaderno',
  props: {
    licao: Object
  },
  data () {
    return {
      topicos: []
    }
  },

  computed: {
    nomeCurso: function () {
      return this.licao.curso ? this.licao.curso.nome : ''
    },

    nomeCategoria: function () {
      if (this.licao) {
        if (this.licao.topicos && this.licao.topicos.length) {
          const anotacoes = this.licao.topicos[0].anotacoes
          return anotacoes && anotacoes.length ? anotacoes[0].nomeCategoria : ''
        } else if (this.licao.nomeCategoria) {
          return this.licao.nomeCategoria
        }
      }
      return ''
    }
  }
}
</script>

<style scoped>

</style>
